export function IconCheck() {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path fill="currentColor" d="M10.707 2.816a1.14 1.14 0 0 1 0 1.526L5.733 9.709a1 1 0 0 1-1.466 0L1.293 6.5a1.14 1.14 0 0 1 0-1.526.95.95 0 0 1 1.414 0L4.853 7.29a.2.2 0 0 0 .294 0l4.146-4.474a.95.95 0 0 1 1.414 0z"/>
        </svg>
    );
}
